module.exports = __webpack_public_path__ + "img/HiraldoKaiLogo.acc51d9a.png";